/** @format */
import React from "react";
import "../styles/SectionA.css";

const SectionA = () => {
  return (
    <div className='footer-container'>
      <footer className='footer'>
        <div className='title'></div>
        <div className='links'>
          <p>Questions? Contact us.</p>
          <ul>
            <li>FAQ</li>
            <li>Media Center</li>
            <li>Ways to Watch</li>
            <li>Cookie Preferences</li>
            <li>Speed Test</li>
          </ul>
          <p>Netflix Nigeria</p>
        </div>
        <div className='list account'>
          <ul>
            <li>Help Center</li>
            <li>Investor Relations</li>
            <li>Terms of Use</li>
            <li>Legal Notices</li>
          </ul>
        </div>
        <div className='list account'>
          <ul>
            <li>Account</li>
            <li>Jobs</li>
            <li>Privacy</li>
            <li>Contact Us</li>
            <li>Only on Netflix</li>
          </ul>
        </div>
        <div className='list'>
          <ul>
            <li>Media Center</li>
            <li>Terms of Use</li>
            <li>Contact Us</li>
          </ul>
        </div>
      </footer>
    </div>
  );
};

export default SectionA;
